import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  //baseURL: 'http://dersyn.digitalnationagency.net/api/',
  // Inlined at build time from .env (VUE_APP_* only)
  baseURL: process.env.VUE_APP_API_URL || 'https://motownsteakhouse.com/api/',
  // baseURL: 'http://localhost:3031/api/',
  headers:{
   
    'Access-Control-Allow-Origin': '*',
    'Content-type': 'application/json'
  
  
  },
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
